class TierChangedBudgetSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.id = systemNotificationPayloadData.id || "";
    this.name = systemNotificationPayloadData.tierId || "";
    this.tokens = systemNotificationPayloadData.tokens || "";
  }
}

export default TierChangedBudgetSystemNotificationPayload;
